import { AxiosResponse } from "axios";
import { ResType } from "../interfaces";
import AxiosRequest from "./api";

interface InitDraftBodyI {
  Payment: {
    modelId: number;
    posSource: string;
    cta: string;
    absoluteUrl: string;
    actionSource: string;
  };
}

const initFlowUrl = process.env.REACT_APP_PAYMENT_API
  ? `${process.env.REACT_APP_PAYMENT_API}/market-place/init-flow`
  : "https://api.sooqdev3.com/v2.1/market-place/init-flow";

const InitDraft = async (
  body: InitDraftBodyI,
  token: string
): Promise<AxiosResponse<ResType>> => {
  return AxiosRequest<ResType>(initFlowUrl, "POST", body, token);
};

export { InitDraft };
